module.exports = __webpack_public_path__ + "img/dark.fdc0f022.svg";